/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {LoadingListener} from '../../../utils/loading/loading-listener';
export class Expand implements LoadingListener {
public expandable: number = 0;
public replace: boolean = false;
private _loading: boolean = false;
/**
 * @return {?}
 */
get loading(): boolean {
        return this._loading;
    }
/**
 * @param {?} value
 * @return {?}
 */
set loading(value: boolean) {
        value = !!value;
        if (value !== this._loading) {
            this._loading = value;
        }
    }
private _expanded: boolean = false;
/**
 * @return {?}
 */
get expanded(): boolean {
        return this._expanded;
    }
/**
 * @param {?} value
 * @return {?}
 */
set expanded(value: boolean) {
        value = !!value;
        if (value !== this._expanded) {
            this._expanded = value;
            this._animate.next();
            this._expandChange.next(value);
        }
    }
private _animate: Subject<any> = new Subject<any>();
/**
 * @return {?}
 */
public get animate(): Observable<boolean> {
        return this._animate.asObservable();
    }
private _expandChange: Subject<boolean> = new Subject<boolean>();
/**
 * @return {?}
 */
public get expandChange(): Observable<boolean> {
        return this._expandChange.asObservable();
    }
/**
 * @return {?}
 */
startLoading(): void {
        this.loading = true;
    }
/**
 * @return {?}
 */
doneLoading(): void {
        this.loading = false;
        this._animate.next();
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function Expand_tsickle_Closure_declarations() {
/** @type {?} */
Expand.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Expand.ctorParameters;
/** @type {?} */
Expand.prototype.expandable;
/** @type {?} */
Expand.prototype.replace;
/** @type {?} */
Expand.prototype._loading;
/** @type {?} */
Expand.prototype._expanded;
/** @type {?} */
Expand.prototype._animate;
/** @type {?} */
Expand.prototype._expandChange;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
